<template>
  <body>
  <div class="pop_translate_wrap">
    <ul>
      <li class="pop_translate_title">
        <h2>{{ trans.ENG_TITLE }}</h2>
        <h3>{{ trans.KOR_TITLE }}</h3>
      </li>
      <li class="pop_translate_cont" v-html="trans.NEWS_SCRIPT_TRANSLATION">
      </li>
    </ul>
    <p class="btnttt"><a href="javascript:window.close()" style="cursor: pointer">닫기</a></p>
  </div>
  </body>
</template>
<script>
import he from 'he'
import {
  GetUrlParams
} from '@/utils/common.js'

export default {
  comments: {
    he
  },

  data: () => ({
    trans: [],
    newsSeq: -1
  }),

  mounted () {
    var oParams = GetUrlParams()
    this.seq = oParams.seq
    this.newsSeq = oParams.news_seq
    this.getTranslate()
  },

  methods: {

    getTranslate () {

      let params = {
        newsSeq: this.newsSeq
      }

      this.axios.get('/v1/api/news/translate', {
        params: params
      })
      .then(res => {
        console.log('getTranslate', res)

        if (res.data.err === 0) {
          if (res.data.trans.NEWS_SCRIPT_TRANSLATION === ''
            || res.data.trans.NEWS_SCRIPT_TRANSLATION === undefined
            || res.data.trans.NEWS_SCRIPT_TRANSLATION === null) {
            res.data.trans = '등록된 번역이 존재하지 않습니다.'
          } else {
            res.data.trans.NEWS_SCRIPT_TRANSLATION = he.decode(
              res.data.trans.NEWS_SCRIPT_TRANSLATION)
            res.data.trans.NEWS_SCRIPT_TRANSLATION = res.data.trans.NEWS_SCRIPT_TRANSLATION.replace(
              /\r\n/gi, '<br/>')
          }
          this.trans = res.data.trans
        } else {
          this.trans = []
        }
      })
    }
  }

}
</script>
<style scoped>
@import '../../assets/scss/css_translate.css';
</style>



// WEBPACK FOOTER //
// src/pages/cafe/popTranslate.vue